import { Badge, InfoIcon } from "../../../components";
import {
  ICreateTxPayoutTag,
  IViewBankAccount,
  IViewBankAccountTag,
} from "../../../interfaces-and-types";

export const PayoutBankAccountDisplay = (props: {
  bankAccount: IViewBankAccount;
  bankTag: IViewBankAccountTag;
  payoutTag: ICreateTxPayoutTag;
}) => {
  const { bankAccount, bankTag, payoutTag } = props;

  if (bankAccount === null) return null;
  if (bankTag === null) return null;
  if (payoutTag === null) return null;

  return (
    <div className="flex-container selected-product--container">
      {/* <div className="product-logo--container">
        <img
          src={bankAccount.bank_logo ?? imagePlaceholder}
          alt="bank logo"
          className="bank-logo--icon"
        />
      </div> */}

      <div className="flex-box flex-col mb-3">
        <Badge
          text={
            <div className="">
              {bankAccount.bank_name} |{" "}
              <span className="text-primary">{bankAccount.account_number}</span>{" "}
              | <span className="">{bankAccount.account_name}</span>
            </div>
          }
          statusColor={"primary"}
          className="mb-3 mr-3"
          hideIndicator
        />
        <Badge
          text={
            <div className="">
              <span className="">{bankAccount.country}</span> | (
              <span className="">{bankAccount.currency}</span>)
            </div>
          }
          statusColor={"danger"}
          hideIndicator
        />
        <InfoIcon
          message={
            <>
              <span className="text-success">{bankTag.tag_name}</span>
              <br />
              <span className="">{bankTag.description}</span>
            </>
          }
        />
      </div>
    </div>
  );
};
